import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HelpAccordion from "../components/helpAccordion";
import HelpData from "../configs/helpData.js";
import { helpPageStyles } from "../../core/styles/cards/helpPageStyles";

const HelpInfo = () => {
  const theme = useTheme();
  const styles = helpPageStyles(theme);

  // Preserve the order categories first appear in the data.
  const categories = HelpData.reduce((acc, item) => {
    const cat = item.category || "General";
    if (!acc.includes(cat)) acc.push(cat);
    return acc;
  }, []);

  return (
    <div>
      {categories.map((category) => (
        <div key={category}>
          <Typography sx={styles.mdFaqCategory}>{category}</Typography>
          {HelpData.filter((item) => (item.category || "General") === category).map(
            (item) => (
              <HelpAccordion
                key={item.id}
                summary={item.summary}
                contentHeader={item.contentHeader}
                contentBody={item.contentBody}
              />
            )
          )}
        </div>
      ))}
    </div>
  );
};

export default HelpInfo;
